<template>
  <div class="payment_help">
    <titleBar :title="title"></titleBar>
    <benefit :benefit-content="content" class="hook"></benefit>
  </div>
</template>
<script>
import  Benefit from "@/components/Benefit/Benefit";
import titleBar from "@/components/common/titleBar.vue";
export default {
  name: 'payment-help',
  data(){
    return {
      title: '支付帮助',
      content: [{
        id: 1001,
        question: "1.会员享受的权益有什么？后续会增加吗？",
        answer:['开通会员后，孩子可以免费享受会员的专属功能及服务（同步练、有声故事、绘本、轻课等），更多会员权益持续开放中，可在会员中心页面查看。']
      },{
        id: 1002,
        question: "2、如何管理/取消自动续费？",
        answer:['对ios苹果支付：打开苹果手机【设置】→进入【iTunes store 与 App Store】→点击【Apple ID】→选择【查看Apple ID】→【账户设置】页面→点击订阅→选择小盒课堂会员取消订阅即可；（此方法适用大多数苹果设备，但因苹果设备型号不同操作不同，如上述方法无法取消，请联系苹果客服取消订阅）','对支付宝支付：打开支付宝【我的-设置】→进入【支付设置】→点击【免密支付/自动扣款】，选择小盒课堂会员取消订阅即可。','对微信支付：打开微信【我】→点击【支付】→点击右上角【···】→点击【扣费服务】选择小盒课堂→【关闭服务】即可']
      },{
        id: 1003,
        question: "3.开通会员后是否可以退款？",
        answer:['会员属于虚拟商品，一经开通不可退款']
      },{
        id: 1004,
        question: "4、如有其他问题请联系客服",
        answer:['客服电话：4000 100 180','在线时间：周一至周日  08:00-22:00']
      }]
    }
  },
  components: {
    Benefit,
    titleBar
  }
}
</script>
<style lang="scss" scoped>
.payment_help{
  .titleBar {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 1.25rem;
  }
  .hook {
    margin-top: 1.65rem;
  }
}
</style>